import { client } from 'Service/axios';
import {
  IPrivateChat,
  IGroupChat,
  ITextMessage,
  IDataMessage,
} from 'Shared/Types/chat';
import { privateChats, groupChats, messages } from 'Shared/Constants/chat';

const CHAT_URL = '/chat/';

class Chat {
  getChatsList(category: 'private' | 'group'): (IPrivateChat | IGroupChat)[] {
    // return client.get<(IPrivateChat | IGroupChat)[]>(`${CHAT_URL}${category}`);
    if (category === 'private') {
      return privateChats;
    } else {
      return groupChats;
    }
  }

  getChatMessages({
    category,
    chatID,
  }: {
    category: 'private' | 'group';
    chatID: number;
  }): (ITextMessage | IDataMessage)[] {
    // return client.get<(IPrivateChat | IGroupChat)[]>(`${CHAT_URL}${category}/${chatID}`);
    return messages;
  }
}


export default Chat;
